import { ConfirmDialog } from '@globaleris/ui.library'
import { Theme, ThemeProvider } from '@material-ui/core/styles'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  closeConfirmationDialog,
  ConfirmationDialogStoreModel,
  RootStoreModel,
  setIsWaitingConfirmationDialog
} from '../../redux'

const confirmationTheme = (theme: Theme): Theme => ({
  ...theme,
  overrides: {
    ...theme.overrides,
    MuiDialogContentText: {
      ...theme.overrides?.MuiDialogContentText,
      root: {
        ...theme.overrides?.MuiDialogContentText?.root,
        whiteSpace: 'pre-line'
      }
    }
  }
})

export const ConfirmationDialog: React.FC = () => {
  const dialog: ConfirmationDialogStoreModel = useSelector(
    (state: RootStoreModel) => state.confirmationDialog && state.confirmationDialog
  )

  const onCloseHandler = async (confirm: boolean): Promise<void> => {
    if (confirm && dialog && dialog.configuration && dialog.configuration.onClose) {
      setIsWaitingConfirmationDialog(true)
      dialog.configuration.onClose(confirm)
    } else {
      dialog.configuration &&
        dialog.configuration.onCancel &&
        dialog.configuration.onCancel(confirm)
      closeConfirmationDialog()
    }
  }

  return (
    <ThemeProvider theme={confirmationTheme}>
      {dialog && dialog.configuration && (
        <ConfirmDialog
          open={dialog.open}
          title={dialog.configuration.title}
          message={dialog.configuration.message}
          okBtnLabel={dialog.configuration.okBtnLabel}
          cancelBtnLabel={dialog.configuration.cancelBtnLabel}
          isWaiting={dialog.configuration.isWaiting}
          onClose={onCloseHandler}
          informationMode={dialog.configuration.informationMode}
        />
      )}
    </ThemeProvider>
  )
}

// USAGE EXAMPLE
// const { getConfirmation } = useConfirmationDialog();
// await getConfirmation(ConfirmationDialogs.CANCEL).then((confirm: boolean) =>
//   confirm && cancel();
// );
